import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { RevealLine, FadeUp } from "@/components/Reveal";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "", tier_interest: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/inquiries", form);
      setSent(true);
      toast.success("Transmission received.", { description: "Response within 24h." });
    } catch (err) {
      toast.error("Could not send. Try again.");
    }
    setBusy(false);
  };

  return (
    <div className="pt-32 pb-24 px-6 md:px-10 min-h-[80svh]" data-testid="contact-page">
      <div className="grid grid-cols-12 gap-6 md:gap-12">
        <div className="col-span-12 md:col-span-6">
          <div className="overline mb-6">Ξ 009 — Encrypted Line</div>
          <h1 className="font-display uppercase text-5xl md:text-7xl tracking-tight leading-[0.9]">
            <RevealLine i={0}>Open a</RevealLine>
            <RevealLine i={1}>transmission.</RevealLine>
          </h1>
          <FadeUp delay={0.2}>
            <p className="mt-8 text-[#888] max-w-md leading-relaxed">
              Consult on threat models, order fleets for your organisation, or request bespoke hardening. We reply
              within 24 hours, Sydney time. All correspondence is encrypted in transit.
            </p>
          </FadeUp>
          <FadeUp delay={0.3}>
            <div className="mt-16 space-y-4">
              <div><div className="overline">Location</div><div className="text-[#EAEAEA] mt-1">Sydney · NSW · Australia</div></div>
              <div><div className="overline">Response window</div><div className="text-[#EAEAEA] mt-1">≤ 24h · AEST</div></div>
              <div><div className="overline">Doctrine</div><div className="text-[#EAEAEA] mt-1">Zero knowledge · zero telemetry · zero exceptions</div></div>
            </div>
          </FadeUp>
        </div>
        <div className="col-span-12 md:col-span-6">
          {sent ? (
            <div className="border border-[#1A1A1A] p-10">
              <div className="overline mb-4">Received</div>
              <div className="font-display text-3xl">Your message is in the vault.</div>
              <p className="mt-6 text-[#888]">We&apos;ll be in touch within 24 hours.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="border border-[#1A1A1A] p-6 md:p-10 space-y-5">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="overline block mb-2">Name</label>
                  <input required className="field" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
                </div>
                <div>
                  <label className="overline block mb-2">Email</label>
                  <input required type="email" className="field" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
                </div>
              </div>
              <div>
                <label className="overline block mb-2">Tier of interest</label>
                <select className="field" value={form.tier_interest} onChange={(e) => setForm({ ...form, tier_interest: e.target.value })} data-testid="contact-tier">
                  <option value="">— select —</option>
                  <option value="degoogled">Tier 01 — Degoogled</option>
                  <option value="secure">Tier 02 — Secure</option>
                  <option value="phantom">Tier 03 — Phantom</option>
                  <option value="fleet">Fleet / bulk</option>
                </select>
              </div>
              <div>
                <label className="overline block mb-2">Subject</label>
                <input required className="field" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" />
              </div>
              <div>
                <label className="overline block mb-2">Message</label>
                <textarea required rows={6} className="field" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
              </div>
              <button type="submit" disabled={busy} className="btn-vault w-full justify-center" data-testid="contact-submit">
                {busy ? "Transmitting…" : "Send transmission"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
